import $ from 'jquery';

/**
 * prevent page scrolling when focusing inputs inside the modal
 */
const lockBodyScrolling = () => {
	document.body.style.top = `${document.body.scrollTop * -1}px`;
	document.body.classList.add('-locked');
};

/**
 * unlock
 */
const unlockBodyScrolling = () => {
	document.body.classList.remove('-locked');
	document.body.scrollTop = parseInt(document.body.style.top, 10) * -1;
	document.body.style.top = 'auto';
};

/**
 * find the flag element in order to get the dataset infomation
 */
const findMarker = (element) => {
	if (element.classList.contains('modal-marker')) {
		return element;
	}

	let target = element.parentNode;
	while (!target.classList.contains('modal-marker')) {
		target = target.parentNode;
	}

	return target;
};

const toggleModal = (target) => {
	const $modal = $('.modal-block');
	const targetElement = findMarker(target);

	$(`.${targetElement.dataset.target}`).toggleClass('-hide');

	if ($modal.hasClass('-show')) {
		$modal.removeClass('-visible');
		setTimeout(() => $modal.removeClass('-show'), 500);
		$modal.find('.closebtn').off('click');

		/**
		 * unlock body
		 */
		unlockBodyScrolling();

		return;
	}

	$modal.addClass('-show -visible');
	$modal.find('.closebtn').on('click', () => {
		toggleModal(targetElement);
		if (!$('.youtube-video').is(':empty')) {
			$('.youtube-video').html('');
		}
	});

	/**
	 * lock body
	 */
	lockBodyScrolling();
};

export default toggleModal;



// WEBPACK FOOTER //
// ./src/js/toggleModal.js